import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DevicesStore, InstallationFeaturesStore } from '@store';
import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsNumberValueProperty,
  IsStringValueProperty,
} from '@vi-iot/client';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-solarlog-overlay',
  templateUrl: './solarlog-overlay.component.html',
  styleUrls: ['./solarlog-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolarLogOverlayComponent implements OnInit, OnDestroy {
  readonly featurePropertyKey = FeaturePropertyKey;

  inverterModel$: Observable<Feature<IsStringValueProperty, never>>;
  inverterManufacturer$: Observable<Feature<IsStringValueProperty, never>>;
  inverterEtn$: Observable<Feature<IsStringValueProperty, never>>;
  inverterInstalledPeakPower$: Observable<Feature<IsNumberValueProperty, never>>;
  gatewayName$: Observable<string>;
  gatewayEtn$: Observable<Feature<IsStringValueProperty, never>>;
  gatewayFirmware$: Observable<Feature<IsStringValueProperty, never>>;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private devicesStore: DevicesStore,
    private installationFeaturesStore: InstallationFeaturesStore,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.gatewayName$ = this.installationFeaturesStore
      .selectInstallationDeviceFeature(FeatureNames.deviceThirdpartyModel)
      .pipe(
        map(
          (feature: Feature<IsStringValueProperty, never>) =>
            feature?.properties?.value?.value ||
            this.translateService.instant(
              '+INSTALLATIONS.INSTALLATION.SOLARLOG.GATEWAY.NAME_DEFAULT'
            )
        )
      );
    this.inverterModel$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceThirdpartyModel
    );
    this.inverterManufacturer$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceThirdpartyManufacturer
    );
    this.inverterEtn$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceEtn
    );
    // photovoltaic.installedPeakPower
    this.inverterInstalledPeakPower$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.photovoltaicInstalledPeakPower
    );

    this.devicesStore.getSolarLogGateway$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(({ id }) => {
        this.gatewayEtn$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
          FeatureNames.deviceEtn,
          id
        );
        this.gatewayFirmware$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
          FeatureNames.deviceThirdpartySoftware,
          id
        );
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
